import Vue from 'vue';
import i18n from '@/i18n.js';
import DateUtils from '@/utils/DateUtils';

Vue.filter('device', function (device) {
    if (!device){
        return null;
    }

    let text = '';
    if (device.identification){
        text += device.identification + ' ';
    }
    if (device.name){
        text += device.name;
    }
    return text;
});


function partNameFilter(part){
    if (!part){
        return null;
    }

    let text = '';

    if (part.identification){
        text += part.identification;
    }
    if (part.name){
        if (text){
            text +=' ';
        }
        text += part.name;
    }

    return text;
}

Vue.filter('part', partNameFilter);

function unitFilter(unit) {
    if (!unit){
        return null;
    }
    return i18n.t('trackingUnit.' + unit);
}

Vue.filter('unit', unitFilter);


Vue.filter('partQuantity', function (partQuantity) {
    if (!partQuantity){
        return null;
    }
    const partName = partNameFilter(partQuantity.part);
    const unit = unitFilter(partQuantity.part.trackingUnit.unit);
    const quantity = partQuantity.quantity;

    return `${partName} ${quantity} ${unit}`;
});


Vue.filter('yesNo', function (value) {
    if (value === null || value === undefined){
        return null;
    }

    if (value){
        return i18n.t('common.yes');
    }
    return i18n.t('common.no');
});

Vue.filter('user', function (user) {
    if (!user){
        return null;
    }

    let text = '';
    if (user.lastName){
        text += user.lastName;
    }
    if (user.firstName){
        if (text){
            text += ', ';
        }
        text += user.firstName;
    }
    if (!text){
        text = user.userName;
    }


    return text;
});

Vue.filter('supplier', function (supplier) {
    if (!supplier) {
        return null;
    }
    return supplier.name;
});

Vue.filter('location', function(location) {
    if (!location) {
        return null;
    }

    let text = '';
    if (location.parentLocationName){
        text = location.parentLocationName + '/';
    }
    text += location.name;

    return text;
});

Vue.filter('date', function (isoDateString) {
    if (!isoDateString){
        return null;
    }
    return i18n.d(DateUtils.ISOdateStringToDate(isoDateString),'date');
});

Vue.filter('dateTime', function (isoDateTimeString) {
    if (!isoDateTimeString){
        return null;
    }
    return i18n.d(new Date(isoDateTimeString),'dateTime');
});

Vue.filter('duration', function(durationMinutes) {

    //On purpose null for zero duration
    if (!durationMinutes) {
        return null;
    }

    const hours = Math.floor(durationMinutes/60);
    let minutes = '' + durationMinutes % 60;
    if (minutes.length < 2){
        minutes = '0'+ minutes;
    }
    return `${hours}:${minutes}`;
});

Vue.filter('priority', function(priority) {

    if (!priority) {
        return null;
    }
    if (priority === 1) {
        return i18n.t('plannedService.priorityOptions.1');
    }
    if (priority === 2) {
        return i18n.t('plannedService.priorityOptions.2');
    }
    if (priority === 3) {
        return i18n.t('plannedService.priorityOptions.3');
    }

    return priority;
});

Vue.filter('serviceState', function(state) {

    if (!state) {
        return null;
    }
    if (state === 'ASSIGNED') {
        return i18n.t('service.stateOptions.ASSIGNED');
    }
    if (state === 'FIXED') {
        return i18n.t('service.stateOptions.FIXED');
    }
    if (state === 'INVALID') {
        return i18n.t('service.stateOptions.INVALID');
    }
    if (state === 'SCHEDULED_IN_DEVELOPMENT') {
        return i18n.t('service.stateOptions.SCHEDULED_IN_DEVELOPMENT');
    }
    if (state === 'IN_PROGRESS_UNAVAILABLE') {
        return i18n.t('service.stateOptions.IN_PROGRESS_UNAVAILABLE');
    }
    if (state === 'IN_PROGRESS_USABLE') {
        return i18n.t('service.stateOptions.IN_PROGRESS_USABLE');
    }
    if (state === 'LEFT_UNDONE') {
        return i18n.t('service.stateOptions.LEFT_UNDONE');
    }

    return state;
});


Vue.filter('defectReportStatus', function(state) {
    if (!state) {
        return null;
    }
    return i18n.t('defectReport.statusOptions.' + state);
});

Vue.filter('serviceRequestState', function(state) {
    if (!state) {
        return null;
    }
    return i18n.t('serviceRequest.stateOptions.' + state);
});

Vue.filter('siteNotificationType', function(type) {
    if (!type) {
        return null;
    }
    return i18n.t('siteNotification.typeOptions.' + type);
});

Vue.filter('siteNotificationActive', function(active) {
    if (active === null || active === undefined) {
        return null;
    }
    if (active) {
        return i18n.t('siteNotification.activeFalse');
    }
    return i18n.t('siteNotification.activeTrue');
});


Vue.filter('location', function(location) {
    if (!location) {
        return null;
    }
    let text = '';
    if (location.parentLocationName) {
        text = location.parentLocationName + ' / ';
    }
    text += location.name;
    return text;
});


Vue.filter('ellipsisMissing', function(value) {
    if (value) {
        return value;
    }
    return '…';
});

/**
 * Prettyprints json object with JSON.stringify
 */
Vue.filter('json', function(json) {
    return JSON.stringify(json, null, 2);
});
